export enum EnumRequestError {
  /** 调用接口失败 */
  XHR_API_FAILED = -1,
  /** 请求url缺少path参数 */
  PATH_PARAM_LOSS = -2,
  /** 缺少认证头，被网关拦截 */
  AUTH_FAILED = -3,
  /** 网络异常｜拿不到状态码 */
  NETWORK_ERROR = -4,
  /** 请求拦截异常 */
  REQUEST_INTERCEPTORS_FAILED = -5,
  /** 成功的回调，但存在错误信息，主动抛错（tip：触发设备绑定） */
  ACTIVE_SETTING_EXCEPTION = -6,
  /** 未知异常 */
  UNKNOW_ERROR = -9999
}

export enum EnumResponseErrorCode {
  /** 设备禁用 */
  DEVICE_BAN = 201100015,
  /** 账号封禁 */
  ACCOUNT_BAN = 201100017,
  /** 地理位置封禁 */
  POSITION_BAN = 201100018,
  /** 老版账号封禁 */
  OLD_ACCOUNT_BAN = 1031100001,
  /** 账号注销中 */
  ACCOUNT_CANCELLING = 1031100058,
  /** 账号已注销 */
  ACCOUNT_CANCEL = 1031100002,
  /** 临时token失效 */
  TEMP_TOKEN_EXPIRED = 1031100029,
  /** 认证已失效（tempToken中的时间、devId发生变化的时候） */
  AUTH_EXPIRED = 2031100001,
  /** 后端没有用到 */
  AUTH_EXPIRED2 = 2031100002,
  /** 账号正在另一台设备登录 */
  LIVE_ACCOUNT_LOGIN_OTHER_DEVICE = 1031100069,
  /** 用户在页面停留电脑休眠导致后端心跳key超时被删除 */
  GENSEE_PAGE_SLEEP = 1032100070
}

export enum EnumHttpCode {
  /** 请求的资源需要认证 */
  Unauthorized = 401,
  /** 没有足够的权限 */
  Forbidden = 403
}

let startTime = Date.now()

/** 获取请求开始时间 */
export function getRequestTime() {
  return startTime
}

/** 请求开始 */
export function requestStart() {
  startTime = Date.now()
}
